import { useMutation } from "@apollo/react-hooks";

import { Learner } from "@hubcapp/types";

import { Test } from "@hubcapp/graphql";
import deleteTestMutation from "../graph-ql/deleteTest.graphql";
import testDetails from "../graph-ql/testDetails.graphql";

const useMutationDeleteTest = (instructorId: string, learnerId: string) =>
  useMutation<{ deleteTest: Test }>(deleteTestMutation, {
    update: (proxy, { data }) => {
      if (data) {
        const learnerQuery = proxy.readQuery<{ learner: Learner }>({
          query: testDetails,
          variables: {
            id: learnerId,
            instructorId,
          },
        });

        if (learnerQuery) {
          proxy.writeQuery({
            query: testDetails,
            variables: {
              id: learnerId,
              instructorId,
            },
            data: {
              learner: {
                ...learnerQuery.learner,
                tests: learnerQuery.learner.tests.filter(
                  existing => existing.id !== data.deleteTest.id,
                ),
              },
            },
          });
        }
      }
    },
  });

export default useMutationDeleteTest;
